import { useState } from "react";
import { MailWarning } from "lucide-react";
import { toast } from "sonner";
import { parentApi, errMsg } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

export const VerifyBanner = () => {
  const { parent } = useAuth();
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  if (!parent || parent.email_verified) return null;

  const resend = async () => {
    setBusy(true);
    try {
      await parentApi.post("/auth/send-verification");
      setSent(true);
      toast.success(`Confirmation email sent to ${parent.email}`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div data-testid="verify-banner" className="zn-card bg-[#FFD23F] p-4 mb-6 flex flex-col sm:flex-row gap-3 sm:items-center">
      <MailWarning size={26} className="shrink-0" />
      <p className="flex-1 text-sm sm:text-base"><b>Please confirm your email.</b> We sent a link to <span className="break-all">{parent.email}</span>. It helps you reset your password if you ever forget it.</p>
      <button data-testid="verify-resend-btn" onClick={resend} disabled={busy || sent} className="zn-btn bg-white !py-2 shrink-0">{sent ? "Sent!" : busy ? "Sending…" : "Resend email"}</button>
    </div>
  );
};
